module.exports = __webpack_public_path__ + "img/spdb.194cc753.jpg";